import { FIELDS_LEAD_PIPEFY, getQueryString } from "./get-query";
import { pipeRequest } from "./pipe-request";
import secretApiAxios from "../../../endpoints/core/secretApiAxios";
import { SetLog, TagLogs } from "../../../logs/set-log";
import { GetWLData } from "../../../wl";

export async function createCard({ data, config, emailAddress }) {
  const wl = await GetWLData();
  const dataQuery = await getQueryString(data, "create", config.pipeType);
  const query = `mutation{createCard(input:{pipe_id: ${config.pipeId},phase_id: ${config.phaseId},fields_attributes: [${dataQuery}]}){clientMutationId card{id}}}`;
  const json = await pipeRequest({ query, config });

  return json;
}
